import {
  AvatarFallback,
  AvatarImage,
  type AvatarSize,
  type AvatarVariant,
  Avatar as ShadcnAvatar,
} from "../ui/avatar"

export interface AvatarProps {
  /**
   * The image source URL for the avatar photo.
   */
  src?: string
  /**
   * The alt text for the avatar image.
   */
  alt?: string
  /**
   * The size of the avatar. Defaults to 'sm'.
   */
  size?: AvatarSize
  /**
   * The variant of the avatar. Defaults to 'photo'.
   */
  variant?: AvatarVariant
  /**
   * Additional className for the root element.
   */
  className?: string
  /**
   * The name of the user.
   */
  name?: string
}

export const Avatar = ({
  src,
  alt,
  size = "sm",
  variant = "square",
  name,
  className,
  ...props
}: AvatarProps) => {
  return (
    <ShadcnAvatar size={size} variant={variant} className={className} {...props}>
      {src ? <AvatarImage src={src} alt={alt} /> : null}
      <AvatarFallback name={name} size={size} variant={variant} />
    </ShadcnAvatar>
  )
}

Avatar.displayName = "Avatar"
